import { FC } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Form, Formik, FormikProps } from 'formik';
import { AssertionsSetsType } from 'entities/Assertions/types';
import { isEmptyObject } from 'shared/helpers/isEmptyObject';
import { isEmptyObjectValues } from 'shared/helpers/isEmptyObjectValues';
import { ActionsForDialog } from 'shared/ui/ActionsForDialog';
import { InputField } from 'shared/ui/InputField';
import { Paper } from 'shared/ui/Paper';
import { AssertionsSetEditorValidationSchema } from 'widgets/Extensions/Details/ui/AssertionSets/ui/AsModals/AssertionsSetEditor/consts/validation';
import { AssertionsSetEditorType } from 'widgets/Extensions/Details/ui/AssertionSets/ui/AsModals/AssertionsSetEditor/types';

interface Props {
	title: string;
	open: boolean;
	handleSubmit: (values: AssertionsSetEditorType) => void;
	handleClose: () => void;
	assertionSetToEdit?: AssertionsSetsType | null;
}

export const AssertionsSetEditor: FC<Props> = ({
	title,
	open,
	handleSubmit,
	handleClose,
	assertionSetToEdit,
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={handleClose} PaperComponent={Paper} PaperProps={{ title }}>
			<Formik
				initialValues={{
					name: assertionSetToEdit?.name || '',
				}}
				validationSchema={AssertionsSetEditorValidationSchema}
				onSubmit={handleSubmit}
			>
				{({ errors, values, resetForm }: FormikProps<AssertionsSetEditorType>) => (
					<Form>
						<InputField
							name={'name'}
							label={t('assertions.label.as_set_name')}
							placeholder={t('assertions.placeholder.as_set_name')}
							required
						/>

						<ActionsForDialog
							cancelLabel={t('shared_texts.cancel')}
							cancelAction={() => {
								resetForm();
								handleClose();
							}}
							applyLabel={t('shared_texts.save')}
							applyActionDisabled={!isEmptyObject(errors) || isEmptyObjectValues(values)}
						/>
					</Form>
				)}
			</Formik>
		</Dialog>
	);
};
